import { Component } from 'react';
import { T } from '../styles/theme';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          background: T.bg, fontFamily: T.fontBody, padding: 24,
        }}>
          <div style={{
            background: T.card, border: `1px solid ${T.border}`, borderRadius: 20,
            padding: 40, textAlign: 'center', maxWidth: 420,
          }}>
            <span style={{ fontSize: '3rem', display: 'block', marginBottom: 16 }}>⚠️</span>
            <h2 style={{ fontFamily: T.fontDisplay, fontSize: '1.4rem', fontWeight: 800, color: T.text, marginBottom: 8 }}>
              Qualcosa è andato storto
            </h2>
            <p style={{ color: T.muted, fontSize: '0.9rem', marginBottom: 24, lineHeight: 1.6 }}>
              Si è verificato un errore imprevisto. Ricarica la pagina per continuare.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: T.gradPrimary, color: 'white', border: 'none',
                padding: '12px 32px', borderRadius: 12, fontSize: '0.9rem',
                fontWeight: 700, cursor: 'pointer', fontFamily: T.fontBody,
              }}>
              Ricarica Pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
